import { HttpService, HttpServiceResponse } from '../shared'
import { LoanOfficerPage, LoanOfficersServerData, AppOfficersServerData } from './loanOfficer.types'

enum ListState {
  Active = 1,
  Inactive = 0,
}

export class LoanOfficerProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/loan_officer_view_api.php`
  }

  public officerList(active: boolean): Promise<HttpServiceResponse<LoanOfficersServerData>> {
    return this.http.post(
      `${this.url}?page=${LoanOfficerPage.OfficerList}&Active=${active ? ListState.Active : ListState.Inactive}`,
    )
  }

  public appList(active: boolean): Promise<HttpServiceResponse<AppOfficersServerData>> {
    return this.http.post(
      `${this.url}?page=${LoanOfficerPage.AppList}&Active=${active ? ListState.Active : ListState.Inactive}`,
    )
  }

  public availableList(loanId: number, loanHash: string): Promise<HttpServiceResponse<LoanOfficersServerData>> {
    return this.http.post(
      `${this.url}?page=${LoanOfficerPage.AvailableList}&LoanID=${loanId}&HashSum_LoanID_=${loanHash}`,
    )
  }
}
